import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isExist } from "cxa-utils";
import { getPropsFromData, InputField, DATE_FORMAT } from "../../FormField";

const DependantRecord = ({ fieldNamePrefix, relationship, data }) => (
  <tr>
    <td>{relationship}</td>
    <td>
      <InputField {...getPropsFromData(data, fieldNamePrefix + "Name")} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, fieldNamePrefix + "Identification")} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, fieldNamePrefix + "Nationality")} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, fieldNamePrefix + "JobTitle")} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, fieldNamePrefix + "Gender")} />
    </td>
    <td>
      <InputField
        {...getPropsFromData(data, fieldNamePrefix + "BirthDate")}
        format={value => isExist(value) && moment(value).format(DATE_FORMAT)}
      />
    </td>
    <td>
      <InputField {...getPropsFromData(data, fieldNamePrefix + "Height")} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, fieldNamePrefix + "Weight")} />
    </td>
  </tr>
);

DependantRecord.propTypes = {
  fieldNamePrefix: PropTypes.string.isRequired,
  relationship: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  data: PropTypes.object,
};

export default DependantRecord;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/DependantRecord.jsx